import './App.css';
import AppRouter from './AppRouter';
import { ToastContainer} from 'react-toastify';
import {refreshToken} from "../src/services/Service"
import Helpers from "../src/utility/Helpers"
//import { useNavigate } from 'react-router-dom';

const App=()=> {
  const handleMouseMove = (event) => { 
    refresh();
    //console.log('Mouse position:', event.clientX, event.clientY); 
  };
  const clearSessionItems =()=> {
    for (var i = 0; i < sessionStorage.length; i++) {
        var a = sessionStorage.key(i);
        sessionStorage.removeItem(a);
    }
}
  const refresh=()=>{
    
    const tokenDateTime=sessionStorage.getItem('tokenDateTime')===undefined || sessionStorage.getItem('tokenDateTime')===null?"":sessionStorage.getItem('tokenDateTime');
    if(tokenDateTime!==""){
      const sessionToken=sessionStorage.getItem('userToken')===undefined || sessionStorage.getItem('userToken')===null?"":sessionStorage.getItem('userToken');
      const body = {
        token: sessionToken
      };
          if(checkDiff(tokenDateTime)>15 && checkDiff(tokenDateTime)<30){
              refreshToken(body).then((res) => {
                sessionStorage.setItem('userToken', res);
                sessionStorage.setItem('tokenDateTime', new Date());
              }).catch((error) => {
                Helpers.handleError(error);
                clearSessionItems();
                window.location.reload();
              });
        }
        else if(checkDiff(tokenDateTime)>29){
          clearSessionItems();
          window.location.reload();
        }
    }
  };
  const handleKeyDown = (event) => {
    refresh();
  };
  const checkDiff=(prev)=>{
    const currenttime = new Date();
    const previous = new Date(prev);

    var diff =(currenttime.getTime() - previous.getTime()) / 1000;
    diff /= 60;
 return Math.abs(Math.round(diff));
  }
  return (
    <div onMouseMove={handleMouseMove} onKeyDown={handleKeyDown}>
    
      <ToastContainer />
      <AppRouter />
    </div>
  );
}

export default App;
